import React from 'react';
import { AppLayout } from './AppLayout';
import Footersection from './Footersection';

interface PagelayoutProps {
  children: React.ReactNode;
  currentPage?: string;
  onNavigate?: (page: string) => void;
  showConnectButton?: boolean;
  // Deprecated props kept for API compatibility
  onConnectWallet?: () => void;
  onDisconnectWallet?: () => void;
  isWalletConnected?: boolean;
  walletAddress?: string;
}

const Pagelayout: React.FC<PagelayoutProps> = ({
  children,
  currentPage,
  onNavigate,
  showConnectButton = true,
}) => {
  return (
    <AppLayout
      currentPage={currentPage}
      onNavigate={onNavigate}
      showConnectButton={showConnectButton}
    >
      {/* Main Content */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
      }}>
        <main style={{
          flex: 1,
          width: '100%',
        }}>
          {children}
        </main>

        {/* Footer */}
        <Footersection onNavigate={onNavigate} />
      </div>
    </AppLayout>
  );
};

export default Pagelayout;
